import { Link } from 'react-router-dom'
import PrivacyChoicesDialog from '@/components/PrivacyChoicesDialog'


export default function SiteFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="py-10 bg-gray-900 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © {year} TopServ Digital. Built with precision for business growth.
          </p>
          <nav aria-label="Legal and accessibility" className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link to="/privacy" className="text-sm text-gray-300 underline-offset-4 hover:text-white hover:underline">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-300 underline-offset-4 hover:text-white hover:underline">
              Terms of Use
            </Link>
            <Link to="/cookies" className="text-sm text-gray-300 underline-offset-4 hover:text-white hover:underline">
              Cookie Policy
            </Link>
            <Link to="/accessibility" className="text-sm text-gray-300 underline-offset-4 hover:text-white hover:underline">
              Accessibility
            </Link>
            <PrivacyChoicesDialog />
            <a
              href="mailto:privacy@topservdigital.com"

              className="text-sm text-gray-300 underline-offset-4 hover:text-white hover:underline"
            >
              Privacy Requests
            </a>
          </nav>
        </div>
      </div>
    </footer>
  )
}
